// mui
import { Alert, CircularProgress, Grid2 } from "@mui/material";
//styling
import styles from "./RestoreTable.module.scss";
// local import
import DataTable from "../../../../../../GlobalComponents/DataTable/DataTable";
// Icons
import { ReactComponent as Time } from "../../../../../../GlobalAssets/svg/Time.svg";
import { ReactComponent as ProcessTime } from "../../../../../../GlobalAssets/svg/ProcessTime.svg";
import { ReactComponent as Status } from "../../../../../../GlobalAssets/svg/Status.svg";
import { ReactComponent as Wpversion } from "../../../../../../GlobalAssets/svg/Wpversion.svg";
import { ReactComponent as Tag } from "../../../../../../GlobalAssets/svg/Tag.svg";
import { CP } from "../../../../../../Utils/roconConstants";
import { formattedDates } from "../../../../../../Utils/utils";
import { ReactComponent as TimeWhiteColor } from "../../../../../../GlobalAssets/svg/TimeWhiteColor.svg";
import { ReactComponent as TagWhiteColor } from "../../../../../../GlobalAssets/svg/TagWhiteColor.svg";
import { ReactComponent as WpversionWhiteColor } from "../../../../../../GlobalAssets/svg/WpversionWhiteColor.svg";
import { ReactComponent as ProcessTimeWhiteColor } from "../../../../../../GlobalAssets/svg/ProcessTimeWhiteColor.svg";
import { ReactComponent as StatusWhiteColor } from "../../../../../../GlobalAssets/svg/StatusWhiteColor.svg";
import { ReactComponent as SftpUser } from "../../../../AdminAssets/svg/SftpUser.svg";
import { ReactComponent as INITIALIZED } from "../../../../../../GlobalAssets/svg/INITIALIZED.svg";
import { ReactComponent as PROCESSING } from "../../../../../../GlobalAssets/svg/PROCESSING.svg";
import { ReactComponent as FINALIZING } from "../../../../../../GlobalAssets/svg/FINALIZING.svg";
import { ReactComponent as SUCCESS } from "../../../../../../GlobalAssets/svg/SUCCESS.svg";
import { ReactComponent as FAILED } from "../../../../../../GlobalAssets/svg/FAILED.svg";

export default function RestoreTable(props) {
  const { filterType, data, sites, userDetails, isDedicatedHosting} = props;
  const columns = [
    {
      id: "dateTime",
      label: "Date & Time",
      icon:
        userDetails === "dark" ? (
          <TimeWhiteColor className={styles.iconColor} />
        ) : (
          <Time className={styles.iconColor} />
        ),
    },
    {
      id: "processTime",
      label: "Process Time",
      icon:
        userDetails === "dark" ? (
          <ProcessTimeWhiteColor className={styles.iconColor} />
        ) : (
          <ProcessTime className={styles.iconColor} />
        ),
    },
    {
      id: "status",
      label: "Status",
      icon:
        userDetails === "dark" ? (
          <StatusWhiteColor className={styles.iconColor} />
        ) : (
          <Status className={styles.iconColor} />
        ),
    },
    {
      id: "wpVersion",
      label: "WP Version",
      icon:
        userDetails === "dark" ? (
          <WpversionWhiteColor className={styles.iconColor} />
        ) : (
          <Wpversion className={styles.iconColor} />
        ),
    },
    {
      id: "tag",
      label: "Tag",
      icon:
        userDetails === "dark" ? (
          <TagWhiteColor className={styles.iconColor} />
        ) : (
          <Tag className={styles.iconColor} />
        ),
    },
  ];

 const rows = data
  ?.sort((a, b) => new Date(b.backupDate) - new Date(a.backupDate))
  .map((item) => ({
    dateTime: (
      <Grid2 className={styles.date}>
        <Grid2>{formattedDates(item?.dateTime)}</Grid2>
      </Grid2>
    ),

    processTime: item?.processTime ? item?.processTime : "-",

    ...(isDedicatedHosting
      ? {
          status: (() => {
            switch (item.status) {
              case "RESTORE_INITIALIZED":
                return <INITIALIZED />;
              case "RESTORE_PROCESSING":
                return <PROCESSING />;
              case "RESTORE_FINALIZING":
                return <FINALIZING />;
              case "RESTORE_SUCCESS":
                return <SUCCESS />;
              case "RESTORE_FAILED":
                return <FAILED />;
              default:
                return <Alert />;
            }
          })(), // <-- FIXED: function must be executed
        }
      : {
          status: (() => {
            switch (item?.status) {
              case "RESTORE_SUCCESS":
                return "Success";
              case "RESTORE_FAILED":
                return "Failed";
              default:
                return "Initiated";
            }
          })(),
        }),

    wpVersion: `${item?.wpVersion} WP Version`,
    tag: item?.tag !== null ? item?.tag : "Note Something",
    backupType: item?.backupType,
  }));

  // const filteredRows = rows.filter((row) => {
  //   if (filterType === "All") return true;
  //   return row.type === filterType;
  // });
  const filteredRows = rows?.filter(
    (row) => filterType === "All" || row.backupType === filterType.toLowerCase()
  );

  const restoreLoading = sites?.restoreDetails;

  return (
    <>
      {restoreLoading ? (
        <Grid2 className={styles.Container}>
          {filteredRows.length > 0 ? (
            <DataTable
              columns={columns}
              rows={filteredRows}
              icon={true}
              enablePagination={true}
              headerProps={{
                titleOptions: [{ label: "" }],
                header: false,
              }}
            />
          ) : (
            <Grid2 className={styles.flexBox}>
              <SftpUser className={styles.SftpUser} />
              <Grid2 className={styles.noData}>No data available</Grid2>
              <Grid2 className={styles.nodatasub}>
                There is no restore data available for this environment.
              </Grid2>
            </Grid2>
          )}
        </Grid2>
      ) : (
        <Grid2 className={styles.loading}>
          <CircularProgress size={CP.SIZE} className={styles.loadingColor} />
        </Grid2>
      )}
    </>
  );
}
